import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartPlotTooltipMotionConstantType,
    ChartPlotDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    MOTION_SURFACE_SCALE,
    type MotionStyleType
} from "../../../../helpers/motion";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

export const CHART_REFETCH_OPACITY = 0.5;

const CHART_PLOT_TOOLTIP_WEB_WIDTH = "max-content" as unknown as number;

const stylesheet = StyleSheet.create({
    tooltip: {
        alignSelf: "flex-start",
        pointerEvents: "none",
        position: "absolute",
        left: 0,
        top: 0,
        ...webStyle({
            width: CHART_PLOT_TOOLTIP_WEB_WIDTH
        })
    },
    container: {
        position: "relative",
        width: "100%",
        ...webStyle({
            outlineStyle: "solid",
            touchAction: "pan-y",
            userSelect: "none",
            cursor: "default",
            outlineWidth: 0
        })
    },
    live: {
        position: "absolute",
        overflow: "hidden",
        opacity: 0
    },
    svg: {
        position: "absolute",
        start: 0,
        top: 0
    },
    unmeasured: {
        opacity: 0
    }
});

export const getChartPlotTooltipMotionStyle = ({
    isReduceMotionEnabled,
    progress,
    isOnEnd,
    offset,
    left,
    top
}: ChartPlotTooltipMotionConstantType): MotionStyleType => {
    if(isReduceMotionEnabled) {
        return {
            transform: [
                {
                    translateX: left
                },
                {
                    translateY: top
                }
            ],
            opacity: progress
        };
    }

    return {
        transformOrigin: isOnEnd ? "left center" : "right center",
        transform: [
            {
                translateX: left
            },
            {
                translateY: top
            },
            {
                translateX: progress.interpolate({
                    outputRange: [
                        isOnEnd ? -offset : offset,
                        0
                    ],
                    inputRange: [
                        0,
                        1
                    ]
                })
            },
            {
                scale: progress.interpolate({
                    outputRange: [
                        MOTION_SURFACE_SCALE,
                        1
                    ],
                    inputRange: [
                        0,
                        1
                    ]
                })
            }
        ],
        opacity: progress
    };
};

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    svgOpacity,
    plotSize,
    radiuses,
    borders,
    colors
}: ChartPlotDynamicStyleType) => {
    const styles = {
        container: {
            height: shapeConfigs.chartHeight[plotSize],
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            }),
            ...getFocusRingStyle({
                isFocusVisible,
                borders,
                colors
            })
        } as Mutable<ViewStyle>,
        live: {
            height: borders.line,
            width: borders.line
        } as Mutable<ViewStyle>,
        svg: {
            opacity: svgOpacity
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
